import abortedIconSrc from '../../assets/icons/orderStatusIcons/aborted.png'
import GenericIcon from './GenericIcon'

const AbortedIcon = ({ className }) => {
  return <GenericIcon src={abortedIconSrc} alt="Aborted Icon" className={className} />
}

export default AbortedIcon
